<template>
    <svg width="40" height="33" viewBox="0 0 40 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.8983 5.48441C38.0104 8.8469 38.6117 12.4403 38.6117 16.1712C38.6117 19.9021 38.0104 23.4954 36.8983 26.8579M31.4886 8.40699C32.3786 10.8291 32.8637 13.4451 32.8637 16.1712C32.8637 18.4318 32.5301 20.6171 31.9084 22.6791C31.8738 22.7939 31.8382 22.9084 31.8018 23.0224C31.7038 23.3296 31.5993 23.634 31.4886 23.9353M25.616 4.08308C25.2904 1.47832 22.2132 0.264038 20.1966 1.94455L11.8799 8.87518C11.7938 8.94691 11.6853 8.9862 11.5732 8.9862H4.60297C2.75118 8.9862 1.25 10.4874 1.25 12.3392V20.0031C1.25 21.8549 2.75118 23.3561 4.60297 23.3561H11.5732C11.6853 23.3561 11.7938 23.3954 11.8799 23.4671L20.1966 30.3977C22.2132 32.0782 25.2904 30.864 25.616 28.2592C26.6194 20.2317 26.6194 12.1106 25.616 4.08308Z" stroke="#130F26" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
    export default {
        name: "VolumeIcon"
    }
</script>

<style scoped>

</style>